import { useCallback, useState } from 'react';

const STORAGE_KEY = 'rate-shopper-promo-dismissed';

const getDismissedSet = (): Set<string> => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return new Set(stored ? JSON.parse(stored) : []);
  } catch {
    return new Set();
  }
};

const buildEntry = (fulfillmentPlanId: string, serviceCollectionGuid: string) => `${fulfillmentPlanId}:${serviceCollectionGuid}`;

export const useRateShopperPromoDismissal = (fulfillmentPlanId: string, serviceCollectionGuid: string): [boolean, () => void] => {
  const entry = buildEntry(fulfillmentPlanId, serviceCollectionGuid);
  const [isDismissed, setIsDismissed] = useState(() => getDismissedSet().has(entry));

  const dismiss = useCallback(() => {
    const set = getDismissedSet();
    set.add(entry);
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    setIsDismissed(true);
  }, [entry]);

  return [isDismissed, dismiss];
};
